import React from "react";
import ReactDOM from "react-dom";
import './index.css';
import DocumentMeta from "react-document-meta";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Config from "./config";

// data management
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <React.StrictMode>
    <DocumentMeta {...Config.header}>
      <Provider store={store}>
        <App />
      </Provider>
    </DocumentMeta>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
